// extracted by mini-css-extract-plugin
export default {"btn-confirm":"TimestampConfirmationDialog_btn-confirm__957oE","btn-cancel":"TimestampConfirmationDialog_btn-cancel__Ck+X4"};